<template>
  <div class="old-globals">
    <form @submit.prevent="signup">
      <md-card class="gray-1 bg">
        <md-progress-bar v-if="loading" md-mode="query" />
        <md-card-header>
          <div class="md-layout md-alignment-center-center header-content">
            <img class="logo" alt="VRpatients Logo" src="../../../assets/images/VRP_Logo.png">
          </div>
        </md-card-header>
        <md-card-content>
          <div v-if="error" class="form-error">{{ error.message || error.error || error }}</div>
          <div v-if="invited">
            An invitation has been sent to the specified email.  Check your email
            and follow the instructions within.
          </div>
          <div v-if="pending">
            You have a pending invitation to {{ state.user.email }}.  Please follow
            the link in your invite email to accept it.
          </div>
          <md-field>
            <md-input v-model.trim="state.user.email" type="email" placeholder="Email" :disabled="invited" required />
          </md-field>
          <md-field v-if="!isFromInviteLink">
            <md-select
              placeholder="Select account type"
              :value="state.accountType"
              @input="value => selectAccountType(value)"
            >
              <md-option value="EMS">
                EMS
              </md-option>
              <md-option value="NURSING">
                Nursing
              </md-option>
            </md-select>
          </md-field>
          <md-field v-if="isFromInviteLink">
            <md-input v-model.trim="state.user.given_name" placeholder="First Name" required />
          </md-field>
          <md-field v-if="isFromInviteLink">
            <md-input v-model.trim="state.user.family_name" placeholder="Last Name" required />
          </md-field>
          <md-field v-if="isFromInviteLink">
            <md-input
              v-model="state.user.password"
              type="password"
              placeholder="Password"
              required
            />
          </md-field>
        </md-card-content>
        <md-card-actions :md-alignment="isFromInviteLink ? 'right' : 'space-between'">
          <router-link v-if="!isFromInviteLink" to="login">Sign in</router-link>
          <md-button type="submit" class="md-raised md-primary" :disabled="invited">Create Account</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
export default {
  name: 'signup-form',
  props: {
    loading: {
      type: Boolean,
    },
    error: {
      type: Object,
      default: null,
    },
    invited: {
      type: Boolean,
      default: false,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      state: {
        accountType: 'EMS',
        user: {
          email: this.$route.query.email || '',
          password: '',
          given_name: '',
          family_name: '',
        },
      },
    };
  },
  computed: {
    isFromInviteLink() {
      return !!this.$route.query.email;
    },
  },
  methods: {
    signup() {
      this.state.user.email = this.state.user.email.toLowerCase();
      this.$emit('signup', this.state.user, this.state.accountType);
    },
    selectAccountType(value) {
      this.state.accountType = value;
    },
  },
};
</script>

<style>
.header-content {
  flex-direction: column;
}
.logo {
  max-width: 100px;
}
</style>
